import {del} from '../utils'

export default host => (channelId, id) => del(`${host}/channels/${channelId}/sections/${id}`)
